import { render, staticRenderFns } from "./CreateBiteModal.vue?vue&type=template&id=41706f1d&scoped=true"
import script from "./CreateBiteModal.vue?vue&type=script&lang=js"
export * from "./CreateBiteModal.vue?vue&type=script&lang=js"
import style0 from "./CreateBiteModal.vue?vue&type=style&index=0&id=41706f1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41706f1d",
  null
  
)

export default component.exports